// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import Paymentbar from './components/paymentbar.vue'
import eventBus from './util/eventBus'


/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      // console.log('-----init', this.model, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      // console.log('-----模型update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {

    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      new Vue({
        el: dom,
        template: '<Paymentbar :invoke="invoke" :model="model"  :paymentBarBean="paymentBarBean" />',
        components: {
          Paymentbar
        },
        data: {
          model: model,
          isSave:false,
          paymentBarBean:{}
        },
        mounted() {
          const self = this

          this.updateSub = eventBus.sub(model, 'update', (props) => {
            console.log('update444',props.data)
            // const { data } = props.data
            console.log('update',props.data.type=='initData')
            if(props.data.type=='initData'){
              console.log('update33',props.data.type=='initData')
               this.paymentBarBean=props.data.paymentBarBean
               console.log('paymentBarBean111',this.paymentBarBean)
             
            }
            
            // console.log('点击调用后台返回接口',props)
            // if(data.type=='sourcehouseshow_save_set'){
            //      console.log('点击保存设置后台返回接口',props)
            //      this.isSave=true
            // }
           
            // if(data.type=='sourcehouseshow_create_label_picture'){
            //      console.log('点击打印后台返回接口',props)
            //      this.isSaveAndPrint=true
            // }
                 
         
            
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          },
          getNameSpace:()=>{
            return KDApi.getNameSpace(model)
           
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('paymentbar', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
